import clsx from 'clsx';
import { createElement } from 'react';

import type {tags} from './tags';

const variants = {
  body: '',
  small: 'text-sm! italic!',
  strong: 'font-semibold!',
  invalid: 'line-through! text-slate11!',
  brand: 'text-blue11! font-semibold!',
  mono: 'font-mono!',
  link: 'underline! text-blue11 hover:no-underline! cursor-pointer',
  error: 'text-tomato11! text-sm!',
} as const;

type Props = React.HTMLAttributes<HTMLParagraphElement> & {
  as?: keyof typeof variants;
  tag?: (typeof tags)[number];
  children: React.ReactNode;
};
export const Text = (
  {
    ref,
    as = 'body',
    tag = 'p',
    children,
    className,
    ...props
  }: Props & {
    ref?: React.RefObject<HTMLParagraphElement>;
  }
) => {
  const style = clsx([className, variants[as]]);
  return createElement(tag, {...props, className: style, ref}, children);
};

Text.displayName = 'Text';
